import { Loader2 } from "lucide-react";
import { GuideButton } from "@/components/GuideButton";

export const Logo = ({ className = "", testid = "brand-logo" }) => (
  <img src="/assets/prospera-logo.webp" alt="PROSPERA+ — Inteligência Financeira & Patrimonial" className={className} data-testid={testid} />
);

export const Icon = ({ className = "h-9 w-9" }) => (
  <img src="/assets/prospera-icon.png" alt="PROSPERA+" className={`${className} rounded-lg object-cover`} data-testid="brand-icon" />
);

export const PageHeader = ({ title, subtitle, children, eyebrow }) => (
  <div className="mb-8 flex flex-col gap-4 md:flex-row md:items-end md:justify-between fade-up">
    <div>
      {eyebrow && <div className="mb-2 text-[11px] font-semibold uppercase tracking-[0.25em] text-[#D4AF37]">{eyebrow}</div>}
      <h1 className="text-3xl font-semibold sm:text-4xl" data-testid="page-title">{title}</h1>
      {subtitle && <p className="mt-2 max-w-2xl text-sm text-slate-400 md:text-base">{subtitle}</p>}
      <div className="mt-2 -ml-3"><GuideButton /></div>
    </div>
    {children && <div className="flex flex-wrap gap-2">{children}</div>}
  </div>
);

const TONES = { gold: "text-[#F5D77F]", green: "text-emerald-400", red: "text-red-400", blue: "text-sky-400", white: "text-white" };

export const Kpi = ({ label, value, hint, tone = "white", icon: I, testid, delay = 0 }) => (
  <div className="card-p p-5 fade-up" style={{ animationDelay: `${delay}ms` }} data-testid={testid}>
    <div className="flex items-center justify-between">
      <span className="text-xs font-medium uppercase tracking-wider text-slate-400">{label}</span>
      {I && <I className="h-4 w-4 text-[#D4AF37]" />}
    </div>
    <div className={`num mt-3 text-2xl font-semibold ${TONES[tone]}`}>{value}</div>
    {hint && <div className="mt-1 text-xs text-slate-500">{hint}</div>}
  </div>
);

export const Section = ({ title, children, action, className = "", testid }) => (
  <section className={`card-p p-5 md:p-6 ${className}`} data-testid={testid}>
    {(title || action) && (
      <div className="mb-4 flex items-center justify-between gap-3">
        <h3 className="text-lg font-semibold">{title}</h3>
        {action}
      </div>
    )}
    {children}
  </section>
);

export const Spinner = ({ label = "Carregando..." }) => (
  <div className="flex items-center gap-2 py-16 text-slate-400" data-testid="loading">
    <Loader2 className="h-5 w-5 animate-spin text-[#D4AF37]" /> {label}
  </div>
);

export const Empty = ({ text, children }) => (
  <div className="rounded-xl border border-dashed border-[#1E3A6E] p-8 text-center text-sm text-slate-400" data-testid="empty-state">
    <p>{text}</p>
    {children && <div className="mt-4">{children}</div>}
  </div>
);

export const Disclaimer = ({ text }) => (
  <p className="mt-6 text-xs italic text-slate-500" data-testid="disclaimer">
    {text || "Conteúdo educacional e cenários hipotéticos; não é recomendação individual de investimento."}
  </p>
);

export const Bar = ({ value, color = "#10B981" }) => (
  <div className="h-2 w-full overflow-hidden rounded-full bg-[#0B1A33]">
    <div className="h-full rounded-full transition-[width] duration-700" style={{ width: `${Math.min(100, Math.max(0, value))}%`, background: color }} />
  </div>
);
